import { useCurrency } from './useCurrency';
import { InsuranceLimit } from './../data/models/insurance.model';

export const useAutoInsurance = (limit: InsuranceLimit | undefined): string => {
  const amount =
    limit?.insuranceLimitState === 'active' ? limit.insuredAmount : undefined;
  return useCurrency(amount);
};
